import type { Browser } from "@shopify/web-pixels-extension";

type BrowserLocalStorage = Browser["localStorage"];

export const setLocalStorageWithExpiry = (
  key: string,
  value: any,
  numHours: number,
  localStorage: BrowserLocalStorage,
) => {
  const ttl = 60 * 60 * 1000 * numHours;
  const now = new Date();
  const item = { value, expiry: now.getTime() + ttl };
  void localStorage.setItem(key, JSON.stringify(item));
};

export const getLocalStorageWithExpiry = async (
  key: string,
  localStorage: BrowserLocalStorage,
) => {
  const itemStr = await localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    return null;
  }
  return item.value;
};

/**
 * Reads the value written by {@link setLocalStorageWithExpiry} without
 * checking `expiry`. Returns undefined for missing or malformed entries.
 */
export const getLocalStorageIgnoreExpiry = async (
  key: string,
  localStorage: BrowserLocalStorage,
): Promise<unknown> => {
  const itemStr = await localStorage.getItem(key);
  if (!itemStr) {
    return undefined;
  }
  try {
    return JSON.parse(itemStr)?.value;
  } catch {
    return undefined;
  }
};
